import {Checkout} from "@/types/front/checkout";

export const translate = (slug: string) => {
    const checkoutOptions: Checkout = window.mCheckout;

    if (checkoutOptions.isDebug) {
        return slug;
    }

    // Type assertion to inform TypeScript about the type
    const translates: { [key: string]: string } = checkoutOptions.translates;

    // let title = slug.replaceAll('_', ' ');

    return translates[slug] || slug;
};
